import React from "react";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";

interface AddReceiptButtonProps {
  langBase: string;
  isActionAvailable: boolean;
  onAddReceipt: () => void;
}

const AddReceiptButton: React.FC<AddReceiptButtonProps> = ({
  langBase,
  isActionAvailable,
  onAddReceipt,
}) => {
  return (
    <FlowActionButton
      langBase={langBase}
      isActionAvailable={isActionAvailable}
      labelKey="add-receipt-button"
      testId="add-receipt"
      variant="contained"
      onClick={onAddReceipt}
    />
  );
};

export default AddReceiptButton;
